<style scoped></style>

<template>
  <div class="card">
    <form >

      <section class="card-content">
        <h1 class="title">Nota(s) do pedido ({{objeto.CODIGO}})</h1>

        <b-table :data="notas" :loading="loadingForm" class="row-button"
                 :paginated="true" detailed>
          <portal-lista-vazia slot="empty"/>

          <template slot-scope="props">

            <b-table-column label="Nº Nota">
              {{ props.row.F2_DOC }}
            </b-table-column>

            <b-table-column label="Valor">
              R${{ props.row.F2_VALMERC }}
            </b-table-column>

            <b-table-column label="Cliente">
              {{ (props.row.cliente && props.row.cliente.A1_NREDUZ) ? props.row.cliente.A1_NREDUZ : props.row.cliente.A1_NOME }}
            </b-table-column>

            <b-table-column label="Transportadora">
              {{ props.row.A4_NOME }}
            </b-table-column>

            <b-table-column label="Filial">
              {{ props.row.F2_FILIAL }}
            </b-table-column>

            <b-table-column label="Loja">
              {{ props.row.F2_LOJA }}
            </b-table-column>

            <b-table-column label="Série">
              {{ props.row.F2_SERIE }}
            </b-table-column>

            <b-table-column label="UF">
              {{ props.row.F2_EST }}
            </b-table-column>

            <b-table-column label="Data Faturamento">
              {{ props.row.F2_EMISSAO | moment("DD/MM/YYYY") }}
            </b-table-column>

            <b-table-column label="Data Envio">
              {{ props.row.C5_EMISSAO | moment("DD/MM/YYYY") }}
            </b-table-column>

            <b-table-column label=""/>

          </template>

          <template slot="detail" slot-scope="props">
            <table class="table is-fullwidth row-button m-t-sm" v-if="props.row.itens.length > 0">
              <tr>
                <th>Código</th> <th>UM</th> <th>Qtd</th> <th>Valor venda</th> <th>Valor total</th> <th>TES</th> <th class="has-text-centered">CF</th>
              </tr>
              <tr v-for="item,i in props.row.itens">
                <td>{{ item.D2_COD }}</td>
                <td>{{ item.D2_UM }}</td>
                <td>{{ item.D2_QUANT }}</td>
                <td>{{ item.D2_PRCVEN | moeda }}</td>
                <td>{{ item.D2_TOTAL | moeda }}</td>
                <td>{{ item.D2_TES }}</td>
                <td class="has-text-centered">{{ item.D2_CF }}</td>
              </tr>
            </table>
          </template>

        </b-table>

      </section>

      <footer>
        <button type="button" class="button" @click="$emit('close')">Fechar</button>
      </footer>
    </form>
  </div>
</template>

<script>
  import { listagem } from '../../mixins/listagem'

  export default {
    mixins: [listagem],
    props: ['objeto'],
    data () {
      return {
        loadingForm: false,
        notas: []
      }
    },
    created () {
      this.carregar()
    },
    methods: {
      carregar () {
        this.loadingForm = true
        this.$http.get(this.$URL.NOTA_FISCAL.NOTA_POR_PEDIDO + this.objeto.CODIGO, this.$header())
          .then(res => {
            this.notas = res.body
            this.loadingForm = false
          }, res => this.mensagemFalhaForm(res))
      },
      toast (res) {
        let msg = res.body.message
        let tipo
        switch (res.status) {
          case 0:
          case 404:
            tipo = 'is-warning'
            msg = 'Ops! Nosso servidor está offline, tente novamente mais tarde.'
            break
          case 422:
            tipo = 'is-danger'
            break
          case 500:
            tipo = 'is-danger'
            msg = 'Ocorreu um problema na conexão com o servidor, caso persista favor contactar o administrator do sistema para uma análise mais detalhada.'
            break
          case 200:
            tipo = 'is-info'
            break
          case 201:
            tipo = 'is-success'
            break
        }
        this.$toast.open({
          message: msg,
          type: tipo,
          duration: 7 * 1000
        })
      },
      mensagemSucessoForm (res) {
        this.toast(res)
        this.$emit('close')
        this.loadingForm = false
      },
      mensagemFalhaForm (res) {
        this.toast(res)
        this.loadingForm = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/pedido/DetalheNota.vue